'use client';

import { AnimateChangeInHeightDiv } from '@/components/AnimateChangeInHeightDiv';
import { fetchTechnologies, technologiesQueryKeys, transformTechnologyForUI } from '@/lib/api/technologies';
import { styled } from '@linaria/react';
import { useQuery } from '@tanstack/react-query';
import { LayoutGroup } from 'motion/react';
import { LowFamiliarityTechsDisplay } from './TechnologiesSectionLowFamiliarity';
import { TechnologyPill } from './TechnologyPill';
import { preload } from 'react-dom';
import { useEffect } from 'react';
import "./TechnologiesSection.linaria.module.css!=!./TechnologiesSection?./TechnologiesSection.linaria.module.css?css=H4sIAAAAAAAAA41WbW+bOhT+vl+BNk1rtybXJKFNQLq6TdK0pIV2HVsWvjngOCaAETjhpep/v+LFhNB2K4qC/Pj4+HnOOT6my0Q3YpjYTwGNCCPUl0PkQkb2SMk6xLdRIotKAG2b+Fj2iH8ihcgTvgnSPj4TRBAi71Qo4GJcD/vdyq4Hiol+PqOsoLXFId35tvxJLB6F7lG4dmks70lEVi5SnruckrxCaxqiAzO4iqi7Y0ixqM+Qz+SPwscDS6AwGshAcdGayUCJic02sgjAZ2WDCN4wOWfUoNAhHsRI3oXuyRcbMigX43+iPf6WeK6yghE6H5w93Og9Mx0PVotkZ2WAwJtHYE3p/q5v9+1U6muptLc8a685l7E2GWW2ZxH1xgzM3/Zk1ccj1bnEmvETa8Y21SaXiT69JA+Yzh9uxhv7GmPTc6PVFBA1m3naYpmYRL2dfHe3Dz/mem6vGb+oZqgD27lK4fQqvb9ZMs1wORZzTL/GieZseppT2ROQaosSuzPmlf2mnqvWiQefZmWj9muM++LYbBn/mI6hSi73r2uYb3RPFbX0SIOkeRW3HudjtvkMqj2lWk/F/aBrVq0p37+cLahsU620WdzXOrmtCt7H+3FrTmdei/eAc9CMMeeZ1PwqLVzbnVFrySob/k4qDQs9q2ycObetNbzM47jSOVa1GSXqZPhtgrdD63oG4GTswUUSPfxQHf36castlpmK6Xyy+D5StyBWp8se93df10Adk7iKSR3bSudCr+uKx1Gv3ubx+KCx5nuoMZuvWWhXOF4QFd9lg9uJkcTL349UvTaD1XU8UomWLg2T6IZGJng7N6eAGMYl1nltNPa4X+BUN8yGhsd2Pmq9utfmc5W1a6rIlfOzx3X+LcbFuXRmnkrGvDbSex47rxHf3GdxtlRR9/OzpQ302TJ9YeO8USvHdTq86+s9MxvcfjlVOjFabQnrNNpXRDIkwx2jQtHk3jUTogBBJpevTtJotsK/X594K5WaTRiuGQpf6cHcGBx14xVljHp/6sIeTE6G4POZMADtO8ElPoJhB4fQJshnJ4wKjAZnQohX8AScCeVPPG0j4PRUef7QjcR4OIAxfeUqYyhhnWgDbRrLQBgGidDLr6e2Y8WDISZ+p1IxyC8MfveBYknpCboE+7KFfIZCvqYQnAedA2Eht0KSThkJnsccqeLWnPVo9sZUE33+z0M2gUJkhQj5AvRt4eRgKYyAGCSnT4141BLyC1p5LmLlw835bv1kkyhwYSoTP4++sqY+K+snv7HLYVwm7gLkqXZpKH9aF08rWmJx5XOwvIvfzbRic9i+V3oruQ6lgbNNGrNit0hGRQcCiCzQCNZ5g4kMhCIHubxOVYNi9zwvGLYbRRYJnhpFytcorZj96evonSL5bgfP4KAxSCJpuNrU6ajPO02UNrZ2UQP0ogJoGhYGDQ+FQScOYSDnf0rTUROuXDWg1hDDQBa7F8WnndjtFeyb+wTQ2vJjUXs7AitjZxcxsk55RfPpN2C+qjh2HcKQF7Wn8t2PTmW9/RH6iodDpkQJvCyb9tl5X655Ol/NtSti68IZkqeXveS4oJv1LjZ7UVH8zx+6KBvte+nF247W0rl0Lv3V0f+IZUY+BgwAAA=="
const TechnologiesSectionContainer = /*#__PURE__*/styled('section')({
  name: "TechnologiesSectionContainer",
  class: "t1lstgid",
  propsAsIs: false
});
const SectionHeader = /*#__PURE__*/styled('div')({
  name: "SectionHeader",
  class: "s1w84awo",
  propsAsIs: false
});
const SectionTitle = /*#__PURE__*/styled('h2')({
  name: "SectionTitle",
  class: "s1nah6uf",
  propsAsIs: false
});
const SectionDescription = /*#__PURE__*/styled('p')({
  name: "SectionDescription",
  class: "s1854jkx",
  propsAsIs: false
});
const TechnologiesContainer = /*#__PURE__*/styled('div')({
  name: "TechnologiesContainer",
  class: "tu9scip",
  propsAsIs: false
});
const PillsWrapper = /*#__PURE__*/styled('div')({
  name: "PillsWrapper",
  class: "pxs58bh",
  propsAsIs: false
});
const LoadingState = /*#__PURE__*/styled('div')({
  name: "LoadingState",
  class: "l1gc7j8i",
  propsAsIs: false
});
const ErrorState = /*#__PURE__*/styled('div')({
  name: "ErrorState",
  class: "ez9v2y7",
  propsAsIs: false
});
export function TechnologiesSection() {
  const {
    data: technologiesResponse,
    isLoading,
    error
  } = useQuery({
    queryKey: technologiesQueryKeys.all,
    queryFn: fetchTechnologies,
    staleTime: 60 * 60 * 1000 // 1 hour
  });
  const header = <SectionHeader>
		<SectionTitle>Technologies & Skills</SectionTitle>
		<SectionDescription>
			A comprehensive overview of technical proficiencies with an honest ranking system.
			Each technology is ranked on a scale of 1-5, where 5 represents expert-level
			proficiency (in practical application) and 1 indicates basic implementation experience
			with minimal customization.
		</SectionDescription>
	</SectionHeader>;
  const technologies = technologiesResponse?.data || [];

  // Transform technologies to match the expected format
  const transformedTechnologies = technologies.map(transformTechnologyForUI);
  const highFamiliarityTechs = transformedTechnologies.filter(tech => tech.familiarity >= 3);
  const lowFamiliarityTechs = transformedTechnologies.filter(tech => tech.familiarity < 3);
  useEffect(() => {
    let canceled = false;
    new Promise(resolve => setTimeout(resolve, 5000)).then(() => {
      if (canceled) return;
      lowFamiliarityTechs.forEach(tech => {
        if ('iconUrl' in tech.mark && tech.mark.iconUrl) preload(tech.mark.iconUrl, {
          as: 'image',
          fetchPriority: 'low'
        });
        if ('wordmarkUrl' in tech.mark && tech.mark.wordmarkUrl) preload(tech.mark.wordmarkUrl, {
          as: 'image',
          fetchPriority: 'low'
        });
      });
    });
    return () => {
      canceled = true;
    };
  }, [lowFamiliarityTechs]);
  if (isLoading) {
    return <TechnologiesSectionContainer>
			{header}
			<TechnologiesContainer>
				<LoadingState>Loading technologies...</LoadingState>
			</TechnologiesContainer>
		</TechnologiesSectionContainer>;
  }
  if (error) {
    return <TechnologiesSectionContainer>
			{header}
			<TechnologiesContainer>
				<ErrorState>Failed to load technologies. Please try again later.</ErrorState>
			</TechnologiesContainer>
		</TechnologiesSectionContainer>;
  }
  return <TechnologiesSectionContainer>
		{header}

		<TechnologiesContainer>
			<LayoutGroup>
				<AnimateChangeInHeightDiv transition={{
          duration: 0.2,
          type: 'spring',
          bounce: 0,
          damping: 8,
          stiffness: 70
        }}>
					<PillsWrapper>
						{highFamiliarityTechs.map(tech => <TechnologyPill key={tech.id} technology={tech} />)}

						<LowFamiliarityTechsDisplay lowFamiliarityTechs={lowFamiliarityTechs} />
					</PillsWrapper>
				</AnimateChangeInHeightDiv>
			</LayoutGroup>
		</TechnologiesContainer>
	</TechnologiesSectionContainer>;
}